import Router from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import guards from './guards'
import comum from './routes/comum'
import cadastros from './routes/cadastros/cadastros'
import configuracao from './routes/configuracao'
import relatorios from './routes/relatorios'
import inicio from './routes/inicio'
import agenda from './routes/agenda'

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'PaginaInicial',
            meta: {
                requiresAuth: true
            },
            redirect: () => {
                return {name: 'Inicio'}
            },
        },
        ...comum,
        ...cadastros,
        ...configuracao,
        ...relatorios,
        ...inicio,
        ...agenda,
    ],
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
})

router.beforeEach((to, from, next) => guards.condicoes(to, from, next))


export default router